import { useSyncExternalStore } from 'react'

import { gostSesija } from './gost'
import { getSession, subscribe } from './session'
import type { SessionState, SessionStore } from './store'

/** Sesija osoblja kao vanjski store: ista istina za React i za `client.ts`. */
export function useSession(): SessionState {
  return useSyncExternalStore(subscribe, getSession, getSession)
}

/** Ista stvar za bilo koju instancu sesije (gost ima svoju). */
export function useSesija(sesija: SessionStore): SessionState {
  return useSyncExternalStore(sesija.subscribe, sesija.getState, sesija.getState)
}

export function useGostSesija(): SessionState {
  return useSesija(gostSesija)
}
